var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPause(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pause"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.875 15.925V4.075C7.875 2.95 7.4 2.5 6.2 2.5H3.175C1.975 2.5 1.5 2.95 1.5 4.075V15.925C1.5 17.05 1.975 17.5 3.175 17.5H6.2C7.4 17.5 7.875 17.05 7.875 15.925Z",
    stroke: "#1C1C1C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M18.5 15.925V4.075C18.5 2.95 18.025 2.5 16.825 2.5H13.8C12.6083 2.5 12.125 2.95 12.125 4.075V15.925C12.125 17.05 12.6 17.5 13.8 17.5H16.825C18.025 17.5 18.5 17.05 18.5 15.925Z",
    stroke: "#1C1C1C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector_3",
    opacity: 0
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPause);
export default __webpack_public_path__ + "static/media/pause.ee9e412459586a7c98eaf758d2a7deb0.svg";
export { ForwardRef as ReactComponent };